import { useClient } from "~/stores/client";
import {sendRedirect} from "h3";
import { getLoginPath } from "~/composables/auth-redirect";
export default defineNuxtPlugin(({ $pinia }) => {
    const requestEvent = useRequestEvent();
    const router = useRouter();
    const runtimeConfig = useRuntimeConfig();
    const url = import.meta.server
        ? runtimeConfig.apiProxyTarget
        : (runtimeConfig.public.apiBase ?? '/api/');

    const IGNORED_PATHS = ['/login', '/logout', '/refresh-token'];

    const $mainFetch = $fetch.create({
        baseURL: url,
        headers: useRequestHeaders(['cookie', 'User-Agent', 'X-Forwarded-For', 'X-Real-IP']),
        retry: 1,
        credentials: 'include',
        retryStatusCodes: [401, 408, 409, 425, 429, 500, 502, 503, 504],
        onRequest({ options }) {
            const headers = new Headers(options.headers);
            if (import.meta.server) {
                const clientIp = headers.get('x-real-ip');
                if (clientIp) {
                    headers.set('Client-Ip', clientIp);
                }
            }

            const client = useClient($pinia);
            if (client.isAuthenticated) {
                headers.set('Authorization', 'Bearer ' + client.accessToken);
            } else {
                headers.delete('Authorization');
            }
            options.headers = headers;
        },
        async onResponseError(ctx) {
            const IS_IGNORE = IGNORED_PATHS.some(path => (ctx.request as string).includes(path));
            const code = ctx.response.status;
            const loginPath = getLoginPath(router.currentRoute.value.fullPath);

            const client = useClient($pinia);
            if (code === 401 && !IS_IGNORE) {
                if (ctx.options.retry === 0) {
                    ctx.response = {
                        status: 401,
                        ...ctx.response
                    };
                    await client.signOut(null);

                    if (import.meta.server) {
                        sendRedirect(requestEvent, loginPath);
                    } else {
                        await router.push(loginPath);
                    }

                    return;
                }
                await client.refreshToken();

                if (client.isAuthenticated) {
                    if (ctx.options.headers instanceof Headers) {
                        ctx.options.headers.set('Authorization', 'Bearer ' + client.accessToken);
                    } else {
                        ctx.options.headers = {
                            ...ctx.options.headers,
                            Authorization: 'Bearer ' + client.accessToken,
                        };
                    }
                }
            } else {
                ctx.options['retry'] = 0;
            }
        }
    });

    return {
        provide: {
            mainFetch: $mainFetch
        }
    }
})
